import axios from 'axios';

import { CLIENT_CODE, SESSION_KEY } from 'utils/constants';
import { urlEncode, removeUndefinedKeys, navigateToLogin } from 'utils';

import { proxy } from '../shared';

import { throwIfErplyError, ErplyApiError } from './erplyErrors';

const { REACT_APP_PARTNER_KEY, NODE_ENV } = process.env;

export const parseErplyResponse = async (response) => {
  if (response.status !== 200) {
    switch (response.status) {
      case 401:
        localStorage.removeItem(SESSION_KEY);
        navigateToLogin();
        throw new Error('This should not be visible');
      case 404:
        throw new ErplyApiError(
          response.data.status.errorCode,
          'Invalid or missing client code',
        );
      default:
        throw new ErplyApiError(
          response.data.status.errorCode,
          `Unknown network error (${
            response.status
          }): ${await response.statusText}`,
        );
    }
  }

  await throwIfErplyError(response.data);
  return response.data;
};

export default {
  request: async (request, params) => {
    const clientCode = localStorage.getItem(CLIENT_CODE);
    const sessionKey = localStorage.getItem(SESSION_KEY);

    const baseURL = `https://${clientCode}.erply.com/api/`;
    const parameters = removeUndefinedKeys(params);
    try {
      const response = await axios({
        baseURL: NODE_ENV === 'development' ? `${proxy}${baseURL}` : baseURL,
        method: 'POST',
        data: urlEncode({
          ...parameters,
          request,
          sessionKey,
          clientCode,
          partnerKey: REACT_APP_PARTNER_KEY,
        }),
        validateStatus: () => true,
      });
      const data = parseErplyResponse(response);
      return await data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
};

/**
 * Mocking ErplyAPI response function for testing purposes
 *
 * @param {String} request - name of the api request
 * @param {Array} records - successful response records
 * @param {Number} errorCode - failure response error code
 */
export const mockServerResponse = (request, records = [], errorCode = null) =>
  errorCode
    ? {
        records: [],
        status: {
          errorCode,
          errorField: '',
          generationTime: 0.029439926147460938,
          recordsInResponse: 0,
          recordsTotal: 0,
          request,
          requestUnixTime: 1573555816,
          responseStatus: 'error',
        },
      }
    : {
        records,
        status: {
          request,
          requestUnixTime: 1573490503,
          responseStatus: 'ok',
          errorCode: 0,
          generationTime: 0.0989990234375,
          recordsTotal: 1,
          recordsInResponse: 1,
        },
      };

export const testUrl = (clientCode) =>
  `${proxy}https://${clientCode}.erply.com/api/`;
